
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import QRCodeGenerator from './QRCodeGenerator';
import FacebookIntegration from './FacebookIntegration';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showVoiceModal, setShowVoiceModal] = useState(false);
  const [showQRGenerator, setShowQRGenerator] = useState(false);
  const [showFacebookIntegration, setShowFacebookIntegration] = useState(false);
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <>
      <header className="bg-gray-900/95 backdrop-blur-sm fixed w-full top-0 z-50 border-b border-gray-800">
        <div className="container mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="text-2xl font-bold text-white" style={{ fontFamily: '"Pacifico", serif' }}>
              MAVESKY TRAVELS
            </Link>
            
            <nav className="hidden md:flex space-x-8">
              <Link to="/" className="text-gray-300 hover:text-white transition-colors">
                Home
              </Link>
              <Link to="/pricing" className="text-gray-300 hover:text-white transition-colors">
                Book Flight
              </Link>
              <Link to="/marketing" className="text-gray-300 hover:text-white transition-colors">
                Marketing
              </Link>
              <Link to="/contact" className="text-gray-300 hover:text-white transition-colors">
                Contact
              </Link>
            </nav>

            <div className="hidden md:flex items-center gap-4">
              <button 
                onClick={() => setShowVoiceModal(true)}
                className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg font-medium transition-colors whitespace-nowrap cursor-pointer flex items-center gap-2"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mic-line"></i>
                </div>
                Voice Search
              </button>
              <button 
                onClick={() => setShowQRGenerator(true)}
                className="bg-purple-600 hover:bg-purple-700 text-white px-4 py-2 rounded-lg font-medium transition-colors whitespace-nowrap cursor-pointer flex items-center gap-2"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-qr-code-line"></i>
                </div>
                QR Code
              </button>
              <button 
                onClick={() => setShowFacebookIntegration(true)}
                className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg font-medium transition-colors whitespace-nowrap cursor-pointer flex items-center gap-2"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-facebook-fill"></i>
                </div>
                Facebook
              </button>
              <Link 
                to="/pricing"
                className="bg-orange-600 hover:bg-orange-700 text-white px-6 py-2 rounded-lg font-medium transition-colors whitespace-nowrap cursor-pointer"
              >
                Book Now
              </Link>
            </div>

            <button 
              className="md:hidden text-white w-6 h-6 flex items-center justify-center cursor-pointer"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
            </button>
          </div>

          {isMenuOpen && (
            <nav className="md:hidden mt-4 pb-4 border-t border-gray-800 pt-4">
              <div className="flex flex-col space-y-4">
                <Link 
                  to="/" 
                  className={`text-white hover:text-blue-400 transition-colors ${isActive('/') ? 'text-blue-400' : ''}`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  Home
                </Link>
                <Link 
                  to="/pricing" 
                  className={`text-white hover:text-blue-400 transition-colors ${isActive('/pricing') ? 'text-blue-400' : ''}`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  Book Flight
                </Link>
                <Link 
                  to="/marketing" 
                  className={`text-white hover:text-blue-400 transition-colors ${isActive('/marketing') ? 'text-blue-400' : ''}`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  Marketing
                </Link>
                <Link 
                  to="/contact" 
                  className={`text-white hover:text-blue-400 transition-colors ${isActive('/contact') ? 'text-blue-400' : ''}`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  Contact
                </Link>
                <button 
                  onClick={() => {
                    setShowVoiceModal(true);
                    setIsMenuOpen(false);
                  }}
                  className="bg-green-600 hover:bg-green-7

                00 text-white px-4 py-2 rounded-lg font-medium transition-colors whitespace-nowrap cursor-pointer text-left flex items-center gap-2"
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-mic-line"></i>
                  </div>
                  Voice Search
                </button>
                <button 
                  onClick={() => {
                    setShowQRGenerator(true);
                    setIsMenuOpen(false);
                  }}
                  className="bg-purple-600 hover:bg-purple-700 text-white px-4 py-2 rounded-lg font-medium transition-colors whitespace-nowrap cursor-pointer text-left flex items-center gap-2"
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-qr-code-line"></i>
                  </div>
                  QR Code
                </button>
                <button 
                  onClick={() => {
                    setShowFacebookIntegration(true);
                    setIsMenuOpen(false);
                  }}
                  className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg font-medium transition-colors whitespace-nowrap cursor-pointer text-left flex items-center gap-2"
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-facebook-fill"></i>
                  </div>
                  Facebook
                </button>
                <Link 
                  to="/pricing"
                  className="bg-orange-600 hover:bg-orange-700 text-white px-6 py-2 rounded-lg font-medium transition-colors whitespace-nowrap cursor-pointer text-left"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Book Now
                </Link>
              </div>
            </nav>
          )}
        </div>
      </header>

      {/* QR Code Generator Modal */}
      <QRCodeGenerator
        isOpen={showQRGenerator}
        onClose={() => setShowQRGenerator(false)}
      />

      {/* Facebook Integration Modal */}
      <FacebookIntegration
        isOpen={showFacebookIntegration}
        onClose={() => setShowFacebookIntegration(false)}
      />
    </>
  );
}
